import * as orderActions from '../actions/orderActions';

const defaultState = {
  incoming: [],
  audited: [],
  readyToShip: [],
  shipped: [],
  archived: []
};

export default function ordersReducer(state = defaultState, action) {
  switch (action.type) {
    case orderActions.INCOMING_ORDERS_FETCHED:
      return { ...state, incoming: action.payload };
    case orderActions.AUDITED_ORDERS_FETCHED:
      return { ...state, audited: action.payload };
    case orderActions.READY_TO_SHIP_ORDERS_FETCHED:
      return { ...state, readyToShip: action.payload };
    case orderActions.SHIPPED_ORDERS_FETCHED:
      return { ...state, shipped: action.payload };
    case orderActions.ARCHIVED_ORDERS_FETCHED:
      return { ...state, archived: action.payload };
    default:
      return state;
  }
}

export const getIdsByStatus = (state, status) => {
  return state[status];
};



// WEBPACK FOOTER //
// ./src/reducers/ordersReducer.js